module.exports = "/images/financial-windfall-background.png?07e7248ba4c37968e45a8486cbeac125";